"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@emotion/core");

var _useTheme2 = _interopRequireDefault(require("../styles/useTheme"));

var _Text = _interopRequireDefault(require("../Text"));

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var shine = (0, _core.keyframes)({
  '0%': {
    transform: 'skewX(-45deg) translateX(-100%)'
  },
  '20%': {
    transform: 'skewX(-45deg) translateX(100%)'
  },
  '100%': {
    transform: 'skewX(-45deg) translateX(100%)'
  }
});

var useStyles = function useStyles() {
  var _useTheme = (0, _useTheme2.default)(),
      spacing = _useTheme.spacing,
      colors = _useTheme.colors;

  return {
    root: {
      display: 'flex',
      alignItems: 'center',
      padding: spacing(0, 1),
      borderRadius: spacing(2),
      backgroundColor: colors.secondary,
      position: 'relative',
      overflow: 'hidden',
      '&:before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 2,
        background: "linear-gradient(\n          to right,\n          ".concat(colors.white, ",\n          ").concat(colors.white, " 60px,\n          transparent 60px\n        )"),
        opacity: 0.3,
        height: '100%',
        width: '100%',
        transformOrigin: 'left bottom',
        animation: "".concat(shine, " 2s ease-in infinite")
      }
    }
  };
};

__signature__(useStyles, "useTheme{{ spacing, colors }}", function () {
  return [_useTheme2.default];
});

var NewFeatureChip = function NewFeatureChip(props) {
  var children = props.children,
      className = props.className,
      style = props.style;
  var classes = useStyles();
  return (0, _core.jsx)("div", {
    css: classes.root,
    className: className,
    style: style
  }, (0, _core.jsx)(_Text.default, {
    variant: "tertiary"
  }, children));
};

__signature__(NewFeatureChip, "useStyles{classes}", function () {
  return [useStyles];
});

var _default = NewFeatureChip;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(shine, "shine", "/builds/bA1zbJom/0/gojob/ui-bits/src/NewFeatureChip/index.tsx");
  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/NewFeatureChip/index.tsx");
  reactHotLoader.register(NewFeatureChip, "NewFeatureChip", "/builds/bA1zbJom/0/gojob/ui-bits/src/NewFeatureChip/index.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/NewFeatureChip/index.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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